import { declareString } from "@1js/localization";

export const NoResultsText = declareString("promptLibrary.noResultsText", {
  text: "No results found. Try different filters.",
  comment:
    "Text that appears when no results are found during prompt filtering",
});

export const NoSavedPromptsTitle = declareString(
  "promptLibrary.noSavedPrompts",
  {
    text: "You don't have any saved prompts yet. Save a prompt, then check back here.",
    comment:
      "When a user filters their prompts by saved prompts only and they don't have any saved prompt, we show this string instead of a grid with prompts. 'prompt' is the text input provided to AI model like GPT",
  }
);
